import React, { useState } from "react";
import Section from "./Section";
import { X_PADDING } from "../constants";
import Page from "./Page";

const Careers = () => {
  return (
    <Page name="Careers">
      <div className="w-full pt-8 bg-white">
        {/*Careers */}
        <Section
          name="jobs"
          description=" Explore job opportunities and career pathways available to clinical officers 
          in Zambia. COAZ provides information on job openings, training programs, 
          and professional development opportunities to support clinical officers in 
          their career advancement and contribute to meaningful healthcare impact"
        />
      </div>
    </Page>
  );
};
export default Careers;
